import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["dataQaType", "loaderSize", "contentMaxLines", "className", "innerClassName", "UNSAFE_className", "UNSAFE_style", "style", "iconLeft", "iconRight", "loading", "children", "wide", "textOverflow"];
import React, { forwardRef } from 'react';
import cn from 'classnames';
import Clickable from '@platform-ui/clickable';
import { useTextFade } from '@tui-react/core';
import { Spinner } from '@tui-react/loader';
import styles from './base-button.module.css';
export const BaseButton = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
      dataQaType = 'tui/button',
      loaderSize = 's',
      contentMaxLines = 1,
      className,
      innerClassName,
      UNSAFE_className,
      UNSAFE_style,
      style,
      iconLeft,
      iconRight,
      loading,
      children,
      wide,
      textOverflow
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const fadeEffect = textOverflow === 'fade';
  const {
    textRef,
    style: fadeStyle
  } = useTextFade({
    enabled: fadeEffect,
    maxLines: fadeEffect ? contentMaxLines : undefined
  });
  return /*#__PURE__*/React.createElement(Clickable, Object.assign({
    dataQaType: dataQaType,
    className: cn(styles.root, className, UNSAFE_className, {
      [styles.root_wide]: wide
    }),
    innerClassName: cn(styles.container, innerClassName),
    style: _extends({}, style, UNSAFE_style, {
      pointerEvents: loading ? 'none' : undefined
    }),
    ref: forwardedRef,
    "aria-busy": loading ? true : undefined
  }, restProps), iconLeft ? /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${dataQaType}.icon`,
    className: styles.icon
  }, iconLeft) : null, children ? /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${dataQaType}.content-wrapper`,
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${dataQaType}.content`,
    className: cn(styles.text, {
      [styles.text_ellipsis]: textOverflow === 'ellipsis'
    }),
    ref: textRef,
    style: fadeStyle
  }, children)) : null, iconRight ? /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${dataQaType}.icon`,
    className: styles.icon
  }, iconRight) : null, loading ? /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${dataQaType}.loader`,
    className: cn({
      [styles.loader]: true
    })
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: loaderSize,
    color: "current"
  })) : null);
});